@if (badge(); as statusBadge) {
    @if (statusBadge.isEscalated && showEscalatedIcon()) {
        <fa-icon [icon]="faExclamationTriangle" class="me-1 red"></fa-icon>
    }
    @if (statusBadge.isCancelled && showCancelledIcon()) {
        <fa-icon [icon]="faBan" class="me-1 red"></fa-icon>
    }
    @if (statusBadge.isUnread && showUnreadIcon()) {
        <fa-icon [icon]="faCircle" class="me-1 orange"></fa-icon>
    }
    <span class="badge-text" [class]="statusBadge.styleClass">{{ statusBadge.text }}</span>
}
